module.exports = function () {
	return require("./index").apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./__main_entry.tmp.js
// module id = 100
// module chunks = 4